module.exports = __webpack_public_path__ + "static/img/call-pass.baa971b6.png";